import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import { PronosticoHidricoState } from '@/store/modules/pronostico-hidrico/types'

export const getters: GetterTree<PronosticoHidricoState, RootState> = {
  getPronosticoHidrico (state: PronosticoHidricoState) {
    return state
  },
  hasLink (state: PronosticoHidricoState) {
    return state.link_descarga || false
  },
  deletePronosticoHidrico (state: PronosticoHidricoState) {
    return state
  }
}
